import React from 'react'
import Container from '../components/Container'
import Title from '../components/Title'

function Partners() {
    return (
        <Container>
            <div className='flex flex-col gap-5'>
                <Title className='text-center !text-black'>
                    Our Trusted Partners
                </Title>
                <div className='text-center text-base md:text-xl'>
                    Collaborating with industry leaders to bring you exceptional service and value.
                </div>
                <div className="mt-5 grid grid-cols-3 sm:grid-cols-7 gap-6 sm:gap-4 lg:gap-8 items-center">
                    <img src={require('../assets/images/partners/Huberag.png')} alt="" className='w-full h-auto' />
                    <img src={require('../assets/images/partners/Stebker.png')} alt="" className='w-full h-auto' />
                    <img src={require('../assets/images/partners/MTS.png')} alt="" className='w-full h-auto' />
                    <img src={require('../assets/images/partners/Sea.png')} alt="" className='w-full h-auto' />
                    <img src={require('../assets/images/partners/Dormakaba.png')} alt="" className='w-full h-auto' />
                    <img src={require('../assets/images/partners/Assa.png')} alt="" className='w-full h-auto' />
                    <div className='block sm:hidden'></div>
                    <img src={require('../assets/images/partners/Glutz.png')} alt="" className='w-full h-auto ' />
                </div>
            </div>
        </Container>
    )
}

export default Partners